import React from 'react';

import './style.css';

const MobileButton = props => {
    const { whichbutton, buttontext, callbackHandler } = props;
    const customClass = whichbutton === 'new' ? 'btn-custom-primary' : 'btn-custom-delete';
    return (
        <button
            type="button"
            id={props.id}
            tabIndex={0}
            className={`btn btn-lg btn-block btn-custom ${customClass}`}
            onClick={() => callbackHandler()}
           
        >
            {buttontext || ""}
        </button>
    );
};

export default MobileButton;
